import type { ComponentEditorMetaDataDefinition } from '../types';
import { documentTypeUtils } from '@wix/santa-editor-utils';

const metaData: ComponentEditorMetaDataDefinition = {
  overrideProportionalResize: true,
  fixedNonPinned: true,
  arrangeable: false,
  rotatable: false,
  supportedInCurrentDocument: () =>
    !documentTypeUtils.isCurrentDocumentTypeIsFluidDocument(),
};

export default metaData;
